import { Card, Image } from "antd";
import Meta from "antd/es/card/Meta";
import "./project-card.scss";
import { LegacyApi, ModernApi } from "@entities/api";
import { useProjectImage } from "@entities/project";
import LocalIcon from "@shared/assets/svg/icons/local_16.svg";
import AvatarFallback from "@shared/assets/webp/avatar-fallback.webp";
import { useNavigate, routes } from "@shared/lib/react-router";


interface ProjectCardProps {
  project: ModernApi.ProjectCardDto | LegacyApi.ProjectCardDto;
  mode: "modern" | "legacy";
}

export const ProjectCard = ({ project, mode }: ProjectCardProps) => {
  const navigate = useNavigate();
  const avatarId = "projectAvatarId" in project ? project.projectAvatarId : "";

  const { data: image } = useProjectImage({
    projectId: project.projectId,
    imageId: avatarId,
    enabled: !!avatarId && !!project.projectId,
  });

  const imageSource = image?.content ?? undefined;

  const shortName =
    "shortName" in project ? project.shortName : project.projectName;

  const fullName =
    "fullName" in project ? project.fullName : project.description;

  const address =
    "addressUnstructured" in project
      ? project.addressUnstructured
      : project.constructionAddress;

  const projectLink =
    mode === "legacy"
      ? routes.general.root(String(`l${project.projectId}`))
      : routes.general.root(String(`${project.projectId}`));

  const handleCardClick = () => {
    navigate(projectLink);
  };

  return (
    <div className="project-card-wrapper" onClick={handleCardClick}>
      <Card
        cover={
          <Image
            src={imageSource || AvatarFallback}
            alt={shortName}
            preview={false}
            fallback={AvatarFallback}
            height={160}
          />
        }
        className="project-card"
      >
        <Meta title={shortName ?? "Проект"} className="project-meta-title" />
        {/* Ни у одного DTO нет этих цифр */}
        {/* <ProjectDetails tasks={0} files={0} folders={0} /> */}
        <Meta
          description={fullName}
          className="project-card-description"
        />
        <div className="project-card-location-row">
          <img
            src={LocalIcon}
            alt="LocalIcon"
            width={16}
            height={16}
            className="project-card-location-icon"
          />
          <div className="project-location">{address}</div>
        </div>
      </Card>
    </div>
  );
};
